var _style, _g, _g2, _path, _line, _ellipse, _ellipse2, _ellipse3, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgType(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 152.5 140",
    style: {
      enableBackground: "new 0 0 152.5 140"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:5;stroke-miterlimit:10;}\n\t.st2{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.7,61v38.4c0,1.2-0.6,2.3-1.6,2.9c-1,0.6-2.3,0.7-3.4,0.2L2.7,88.1c-1.2-0.6-1.9-1.8-1.9-3.1V49.1 c0-1.2,0.6-2.2,1.5-2.8c0.6-0.4,1.3-0.6,1.9-0.6c0.4,0,0.8,0.1,1.2,0.2l0.1,0l30.2,11.9C36.9,58.4,37.7,59.6,37.7,61z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.2,46.8v39.3c0,1.3-0.8,2.5-2,3L46.4,103c-1,0.4-2.2,0.3-3.1-0.3c-0.9-0.6-1.5-1.6-1.5-2.7V60.7 c0-1.3,0.8-2.5,2-3l0,0l32.8-13.9c0,0,0,0,0,0c0.4-0.2,0.9-0.3,1.3-0.3c0.6,0,1.3,0.2,1.8,0.5C80.6,44.7,81.2,45.7,81.2,46.8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.4,127.7H116c-2.9,0-5.3-2-5.3-4.6V16.7c0-2.2,2.1-4.1,4.7-4.1h13.8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 90.4,
    y1: 69.7,
    x2: 128.1,
    y2: 69.7
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 139.8,
    cy: 12.2,
    rx: 12.2,
    ry: 12
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 139.8,
    cy: 70.2,
    rx: 12.2,
    ry: 12
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 139.8,
    cy: 128.2,
    rx: 12.2,
    ry: 12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.7,42.4L38,54.7c0.4,0.2,0.9,0.2,1.3,0l33.4-14.2c1.4-0.6,1.4-2.5,0-3.1L41.4,24.3c-0.4-0.2-0.9-0.2-1.4,0 L6.6,39.4C5.3,40,5.3,41.9,6.7,42.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgType);
export default __webpack_public_path__ + "static/media/Type.be88f9932805cad6dd0441580cf3fea6.svg";
export { ForwardRef as ReactComponent };